import { useQueryClient } from "@tanstack/react-query";
import classNames from "classnames";

import { ReactQueryKeysAccount } from "services/queryKeys";

import DocumentOutputRefreshIcon from "assets/icons/DocumentOutputRefreshIcon.svg?react";

import styles from "./styles.module.scss";

export const DatabasesRefresher = () => {
  const queryClient = useQueryClient();
  const refreshDatabases = () => {
    queryClient.invalidateQueries({
      queryKey: [ReactQueryKeysAccount.databasesNames],
    });
  };

  return (
    <DocumentOutputRefreshIcon
      onClick={refreshDatabases}
      className={classNames(styles.icon, styles.refreshIcon)}
    />
  );
};
